<div class="card">
  <div class="card-body">
    <a [routerLink]="'/jobs'" class="card-title h5">
      <span class="material-symbols-outlined">work</span>
      <span style="vertical-align: middle" class="ms-2">{{ configuration.title }}</span>
    </a>
    @if (configuration.description) {
      <h6 class="card-subtitle mb-2 mt-2 text-muted">{{ configuration.description }}</h6>
    }
    @if (!isLoading) {
      <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
    }
    <app-card-bar [title]="'jobs'" [data]="jobData"></app-card-bar>
  </div>
</div>
